/**
 * @file: maskedLicensePlateNo.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

export const maskedLicensePlateNo = (s: string) =>
  s.substring(0, 2) + '*' + s.substring(3);
